module.exports = __webpack_public_path__ + "img/pc.a5747ad0.svg";